import { Extension } from '@tiptap/core';
import { Plugin } from '@tiptap/pm/state';
import { CellSelection } from '@tiptap/pm/tables';

export const TABLE_CONTEXT_EVENT = 'document-table-context';
export const DocumentTableContext = Extension.create({
    name: 'documentTableContext',
    addProseMirrorPlugins() {
        const editor = this.editor;
        return [new Plugin({ props: { handleDOMEvents: {
            // A right-click's mousedown would otherwise collapse an existing
            // multi-cell selection before contextmenu fires. Keep it when the
            // pressed cell is inside the selection; otherwise let the normal
            // collapse happen (contextmenu then selects the clicked cell).
            mousedown(view, event) {
                if (event.button !== 2 || !(view.state.selection instanceof CellSelection)) return false;
                const cell = (event.target as HTMLElement).closest('td,th');
                if (!cell || !view.dom.contains(cell) || !editor.isEditable) return false;
                const pos = view.posAtDOM(cell, 0) - 1;
                let inside = false;
                view.state.selection.forEachCell((_node, cellPos) => { if (cellPos === pos) inside = true; });
                if (inside) event.preventDefault();
                return inside;
            },
            contextmenu(view, event) {
                const cell = (event.target as HTMLElement).closest('td,th');
                if (!cell || !view.dom.contains(cell) || !editor.isEditable) return false;
                const pos = view.posAtDOM(cell, 0) - 1;
                // Keep a multi-cell selection when right-clicking inside it, so
                // merge acts on that rectangle rather than just the clicked cell.
                const selection = view.state.selection;
                let selected = false;
                if (selection instanceof CellSelection) selection.forEachCell((_node, cellPos) => { if (cellPos === pos) selected = true; });
                if (!selected) view.dispatch(view.state.tr.setSelection(CellSelection.create(view.state.doc, pos)));
                event.preventDefault();
                view.dom.dispatchEvent(new CustomEvent(TABLE_CONTEXT_EVENT, { detail: { x: event.clientX, y: event.clientY } }));
                return true;
            },
        } } })];
    },
});
